const { get } = require('lodash')

const bodyParser = ({ response, path }) => ({
  body: JSON.parse(get(response, `data.${path}.body`)),
  statusCode: get(response, `data.${path}.statusCode`)
})

export default bodyParser
